import React from "react";
import { Stack, Typography, Box } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import * as SC from "SC";

/**
 * OnboardingSuccessPage
 *
 * Shown after a successful Stripe Checkout payment.
 * Stripe redirects to: /onboarding/success?session_id=...
 */
export const OnboardingSuccessPage = () => {
  return (
    <SC.AuthFormContainer>
      <Stack gap={3} alignItems="center" sx={{ textAlign: "center", py: 4 }}>
        <CheckCircleIcon sx={{ fontSize: 72, color: "success.main" }} />

        <Stack gap={1}>
          <Typography variant="h5" fontWeight={800}>
            You're all set! 🎉
          </Typography>
          <Typography variant="body1" color="text.secondary" maxWidth={400}>
            Your FleetMD account is being set up. You'll receive a welcome email
            with your login instructions shortly.
          </Typography>
        </Stack>

        <Box
          sx={{
            backgroundColor: "action.hover",
            borderRadius: 2,
            p: 2,
            maxWidth: 380,
            width: "100%",
          }}
        >
          <Typography variant="body2" color="text.secondary" fontWeight={600} mb={0.5}>
            Next steps:
          </Typography>
          <Stack gap={0.5} alignItems="flex-start">
            {[
              "Check your email for login credentials",
              "Complete your company profile",
              "Add your drivers and vehicles",
              "Start dispatching rides",
            ].map((step, i) => (
              <Typography key={step} variant="body2" color="text.secondary">
                {i + 1}. {step}
              </Typography>
            ))}
          </Stack>
        </Box>

        <SC.ControlButton
          variant="contained"
          href="/"
          sx={{ minWidth: 200 }}
        >
          Go to Login
        </SC.ControlButton>

        <Typography variant="caption" color="text.secondary">
          Need help? Contact{" "}
          <a href="mailto:support@fleetmd.io" style={{ color: "inherit" }}>
            support@fleetmd.io
          </a>
        </Typography>
      </Stack>
    </SC.AuthFormContainer>
  );
};

export default OnboardingSuccessPage;
